import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
function ModalFooter(_ref) {
  var className = _ref.className,
    children = _ref.children,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsx("div", {
    className: classNames('modal-footer', className),
    "data-testid": dataTestId,
    children: children
  });
}
export default ModalFooter;
//# sourceMappingURL=ModalFooter.js.map